
import React from 'react'

import common from '../../../assets/common.jpg'
import MegaNavbar from '../../../Components/MegaNavbar'
import DrNajma_CV from '../../../assets/CVs/Statistics/DrNajma_CV.pdf'
import UpdatedCVSundusHUSSAIN from '../../../assets/CVs/Statistics/UpdatedCVSundusHUSSAIN.pdf'

import Footer from '../../../Components/Footer'

const Statistics = () => {
  return (
    <>
    

    <MegaNavbar/>
     <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Statistics</h2>
       
        <p>Faculty of Statistics.</p>
      </div>

      <div className="row">

      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Najma Salahuddin </h4>
              <span>Lecturer Department of Statistics.</span>
              <p>Lecturer Department of Statistics Shaheed Benazir Bhutto Women University Peshawar .</p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>   najma@sbbwu.edu.pk </p>
              <div className="social">
                <a href={DrNajma_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 


      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Sundus Hussain  </h4>
              <span>Lecturer Department of Statistics.</span>
              <p>Lecturer at the Department of Statistics, Shaheed Benazir Bhutto Women University Peshawar. </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> sundashusain@sbbwu.edu.pk  </p>
              <div className="social">
                <a href={UpdatedCVSundusHUSSAIN}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 
 

        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>
      <Footer/>
  
      
    </>
  )
}

export default Statistics
